module.exports = __webpack_public_path__ + "img/170.dining_room.2a58d2bf.svg";